import { render, staticRenderFns } from "./CheckoutOld.vue?vue&type=template&id=5665993d"
import script from "./CheckoutOld.vue?vue&type=script&lang=js"
export * from "./CheckoutOld.vue?vue&type=script&lang=js"
import style0 from "./CheckoutOld.vue?vue&type=style&index=0&id=5665993d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports